const UUID_V4_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isValidUuidV4 = (value: string): boolean => UUID_V4_REGEX.test(value);

// sessionStorage keys from backend technical design doc (DRAFT)
export const SH_SPRING_ID = 'sh_spring_id';
export const SH_SESSION_START = 'sh_session_start';
export const SH_PRODUCT = 'sh_product';
export const SH_SESSION_ID = 'sh_session_id';

// Generate a UUID v4 session identifier for analytics tracking
export const generateSessionId = (): string => crypto.randomUUID();

export const SPRING_HEALTH_RETURN_URLS: Record<string, string> = {
  sleepio: 'https://care.springhealth.com/members/discover/programs/sleepio',
  daylight: 'https://care.springhealth.com/members/discover/programs/daylight',
};
